import {
  chakra,
  ChakraComponent,
  Modal as ChakraModal,
  ModalProps,
  ModalOverlay as ChakraModalOverlay,
  ModalOverlayProps,
  ModalHeader as ChakraModalHeader,
  ModalHeaderProps,
  ModalBody as ChakraModalBody,
  ModalBodyProps,
  ModalCloseButton as ChakraModalCloseButton,
  CloseButtonProps,
} from '@chakra-ui/react';
import React from 'react';
import { styleImports } from './DepositLimitModal.styles.imports';
import { getThemeName } from '@/helpers/getThemeConfig';

const themeName = getThemeName();

export const Modal = (props: ModalProps) => {
  const size = 'lg';
  return <ChakraModal size={size} {...props} />;
};

export const ModalOverlay: ChakraComponent<'div', ModalOverlayProps> = chakra(
  ChakraModalOverlay,
  {
    label: 'DepositLimitModalOverlay',
    baseStyle: ({ theme }) => ({
      ...(() => {
        try {
          return styleImports[themeName]?.ModalOverlay?.(theme);
        } catch (err) {
          return {};
        }
      })(),
    }),
  }
);

export const ModalHeader: ChakraComponent<'header', ModalHeaderProps> = chakra(
  ChakraModalHeader,
  {
    label: 'DepositLimitModalHeader',
    baseStyle: {
      ...(() => {
        try {
          return styleImports[themeName]?.ModalHeader;
        } catch (err) {
          return {};
        }
      })(),
    },
  }
);

export const ModalBody: ChakraComponent<'div', ModalBodyProps> = chakra(
  ChakraModalBody,
  {
    label: 'DepositLimitModalBody',
    baseStyle: {
      ...(() => {
        try {
          return styleImports[themeName]?.ModalBody;
        } catch (err) {
          return {};
        }
      })(),
    },
  }
);

export const ModalCloseButton: ChakraComponent<'button', CloseButtonProps> =
  chakra(ChakraModalCloseButton, {
    label: 'DepositLimitModalCloseButton',
    baseStyle: {
      ...(() => {
        try {
          return styleImports[themeName]?.ModalCloseButton;
        } catch (err) {
          return {};
        }
      })(),
    },
  });
